import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ProductCard from '@/components/base/ProductCard';
import { products, categories } from '@/mocks/products';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredProducts = activeCategory === 'all'
    ? products
    : products.filter((p) => p.category === activeCategory);

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '爱液官网产品中心 - 全线润滑液产品系列',
    description: '浏览爱液官网全线正品润滑液产品：水基润滑液、硅基润滑液、天然植萃系列。了解产品成分、使用方法及安全购买入口。',
    url: 'https://www.aiye-official.com/categories'
  };

  return (
    <>
      <SEOHead
        title="产品中心 - 爱液官网正品润滑液全系列 | 水基硅基天然植萃"
        description="爱液官网产品中心，展示全线正品润滑液产品：水基润滑液、硅基润滑液、天然植萃系列。了解每款产品的成分、功效与使用方法，官网直营正品保障。"
        keywords="爱液官网产品系列,爱液润滑液官方,爱液官网正品购买,水基润滑液,硅基润滑液,天然润滑液"
        canonicalUrl="/categories"
        structuredData={categorySchema}
      />

      <Navbar />

      <main className="pt-16 md:pt-18">
        <Breadcrumb
          items={[
            { label: '首页', to: '/' },
            { label: '产品中心' }
          ]}
        />

        {/* Page Header */}
        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="w-full px-4 md:px-6 text-center">
            <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
              产品中心
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              爱液全线正品润滑液产品，从水基到硅基，从日常保湿到修护滋养，满足你的每一种需求
            </p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="w-full bg-background-50 sticky top-16 md:top-18 z-40 border-b border-background-200">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center gap-2 py-3 overflow-x-auto">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`px-5 py-2.5 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="w-full bg-background-50 py-10 md:py-14" data-product-shop>
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredProducts.map((product) => (
                <ProductCard key={product.id} {...product} />
              ))}
            </div>
            {filteredProducts.length === 0 && (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-500">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-600">该分类暂无产品</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}